<template>
<div class="centered-cards">
    <router-link to="/list">
    <div class="card">
        <h2>Total Enhancer</h2>
    </div>
    </router-link>

    <router-link to="/Enhancer">
    <div class="card">
        <h2>Common Enhancer</h2>
    </div>
    </router-link>
</div>
</template>

<script>
export default {
    methods: {
        
    }
};
</script>

<style scoped>
.centered-cards {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.card {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 20px;
    margin: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.card:hover {
    background-color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Transitions.vue